import axios from 'axios';
import config from 'config/config';
const {
  SOLARIS_API_PATH,
  SOLARIS_API_PUBLIC_PATH,
  AURORA_API_PATH,
  DISCOVER_API_PATH,
  DISCOVER_API_KEY,
} = config;
const isServer = typeof window === 'undefined';

axios.defaults.withCredentials = true;

export const createAuthenticatedApiInstance = (getState) => {
  // Note: the cookie is only required by the server side as the client side already have the cookie set
  const authHeaders = getState
    ? generateServerAuthHeaders(getState)
    : {};

  return createApiInstance(authHeaders);
};

// 'createApiInstance' is used to customise the request headers on the server
// this is mainly used to set the cookie on the server side for authenticated requests
export const createApiInstance = (apiConfig) => {
  return {
    get: (url, config = {}) => {
      return axios.get(`${SOLARIS_API_PATH}${url}`, {
        ...apiConfig,
        ...config,
      });
    },

    getPublic: (url, config = {}) => {
      return axios.get(`${SOLARIS_API_PUBLIC_PATH}${url}`, {
        ...apiConfig,
        ...config,
      });
    },

    post: (url, args = {}, config = {}) => {
      return axios.post(`${SOLARIS_API_PATH}${url}`, args, {
        ...apiConfig,
        ...config,
      });
    },

    put: (url, args = {}, config = {}) => {
      return axios.put(`${SOLARIS_API_PATH}${url}`, args, {
        ...apiConfig,
        ...config,
      });
    },

    putPublic: (url, args = {}, config = {}) => {
      return axios.put(`${SOLARIS_API_PUBLIC_PATH}${url}`, args, {
        ...apiConfig,
        ...config,
      });
    },

    del: (url, args = {}, config = {}) => {
      return axios.delete(`${SOLARIS_API_PATH}${url}`, args, {
        ...apiConfig,
        ...config,
      });
    },

    auroraGet: (url, config = {}) => {
      return axios.get(`${AURORA_API_PATH}${url}`, {
        ...apiConfig,
        ...config,
      });
    },

    auroraPost: (url, args = {}, config = {}) => {
      return axios.post(`${AURORA_API_PATH}${url}`, args, {
        ...apiConfig,
        ...config,
      });
    },

    auroraPut: (url, args = {}) => {
      return axios.put(`${AURORA_API_PATH}${url}`, args, {
        ...apiConfig,
        ...config,
      });
    },

    auroraDel: (url, args = {}, config = {}) => {
      return axios.delete(`${AURORA_API_PATH}${url}`, args, {
        ...apiConfig,
        ...config,
      });
    },

    discoverGet: (url, config = {}) => {
      return axios.get(`${DISCOVER_API_PATH}${url}`, {
        headers: {
          'Authorization': DISCOVER_API_KEY,
        },
        withCredentials: false,
        ...config,
      });
    },

    externalGet: (url) => {
      return axios.get(url, {
        withCredentials: false,
      });
    },

  };
};

// Generates server authentication headers for server side requests
export const generateServerAuthHeaders = (getState) => {
  if (!isServer) return {};
  const { context: { sessionId } } = getState();
  return {
    headers: {
      Cookie: sessionId ? `huSessID=${sessionId};` : '',
    },
  };
};


const defaultApi = createApiInstance();
export default defaultApi;
